import { useState } from "react";
import { Link } from "react-router-dom";
import { LogoMark, ShieldIcon, EyeIcon, EyeOffIcon } from "../ui/Icons";

export default function AdminLogin({ login, loginError, loginLoading, loginAttempts }) {
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);

  const submit = () => login(password);

  return (
    <div style={{ minHeight: "100vh", background: "var(--bg)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, position: "relative" }}>
      <div className="grid-bg" style={{ position: "absolute", inset: 0, opacity: 0.5 }} />
      <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", width: 480, height: 480, borderRadius: "50%", background: "radial-gradient(circle, rgba(201,168,76,0.065) 0%, transparent 65%)", filter: "blur(60px)", pointerEvents: "none" }} />

      <div className="anim-fade-in" style={{ position: "relative", width: "100%", maxWidth: 420, background: "var(--bg-3)", border: "1px solid var(--border)", borderRadius: 22, padding: "44px 40px", boxShadow: "0 40px 100px rgba(0,0,0,0.55)" }}>
        <div style={{ position: "absolute", top: 0, left: "50%", transform: "translateX(-50%)", width: "65%", height: 1, background: "linear-gradient(90deg, transparent, rgba(201,168,76,0.35), transparent)" }} />

        {/* Back */}
        <Link to="/" style={{ position: "absolute", top: 16, left: 16, color: "var(--text-muted)", textDecoration: "none", fontSize: "0.78rem", display: "flex", alignItems: "center", gap: 4, transition: "color 0.2s" }}
          onMouseEnter={e => e.currentTarget.style.color = "var(--text-dim)"}
          onMouseLeave={e => e.currentTarget.style.color = "var(--text-muted)"}
        >← Back</Link>

        <div style={{ textAlign: "center", marginBottom: 34 }}>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 18 }}><LogoMark size={38} /></div>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: "var(--gold-dim)", border: "1px solid var(--gold-border)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px", color: "var(--gold)" }}>
            <ShieldIcon size={22} />
          </div>
          <h1
            style={{
              fontFamily: "Syne, sans-serif",
              fontSize: "1.5rem",
              fontWeight: 700,
              letterSpacing: "-0.01em",
              lineHeight: 1.2,
              marginBottom: 8
            }}
          >
            Admin Access
          </h1>
          <p style={{ fontSize: "0.84rem", color: "var(--text-dim)" }}>Enter your password to access the dashboard</p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 13 }}>
          <div style={{ position: "relative" }}>
            <input
              className={`input${loginError ? " has-error" : ""}`}
              type={show ? "text" : "password"}
              placeholder="Admin password"
              value={password}
              onChange={e => { setPassword(e.target.value); }}
              onKeyDown={e => e.key === "Enter" && submit()}
              disabled={loginLoading || loginAttempts >= 5}
              style={{ paddingRight: 46 }}
              autoComplete="current-password"
            />
            <button onClick={() => setShow(s => !s)} style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", background: "transparent", border: "none", color: "var(--text-muted)", cursor: "pointer", display: "flex", transition: "color 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.color = "var(--text-dim)"}
              onMouseLeave={e => e.currentTarget.style.color = "var(--text-muted)"}
            >
              {show ? <EyeOffIcon size={16} /> : <EyeIcon size={16} />}
            </button>
          </div>

          {loginError && <p style={{ fontSize: "0.77rem", color: "var(--red)", display: "flex", alignItems: "center", gap: 5 }}><span>⚠</span> {loginError}</p>}

          <button
            className="btn-gold"
            onClick={submit}
            disabled={loginLoading || loginAttempts >= 5 || !password}
            style={{ padding: "14px", borderRadius: 10, fontSize: "0.9rem", gap: 8, width: "100%" }}
          >
            {loginLoading
              ? <><span style={{ width: 14, height: 14, border: "2px solid rgba(0,0,0,0.2)", borderTopColor: "#050508", borderRadius: "50%", display: "inline-block", animation: "spin 0.65s linear infinite" }} /> Verifying...</>
              : "Access Dashboard"
            }
          </button>

          {loginAttempts > 0 && loginAttempts < 5 && (
            <p style={{ textAlign: "center", fontSize: "0.72rem", color: "var(--red)" }}>
              {5 - loginAttempts} attempt{5 - loginAttempts !== 1 ? "s" : ""} remaining
            </p>
          )}
        </div>

        <div className="divider-gold" style={{ margin: "24px 0" }} />
        <p style={{ textAlign: "center", fontSize: "0.71rem", color: "var(--text-muted)" }}>Protected area · Alpha Stack Admin v2.0</p>
      </div>
    </div>
  );
}
